// components/website/consent-gated-analytics.tsx
"use client";

import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import {
  readConsentFromDocument,
  type ConsentLevel,
} from "@/lib/consent";

/**
 * Mounts Vercel Analytics only when the visitor has chosen "all".
 * Listens for the `fm-consent-changed` event the banner dispatches so
 * the user doesn't have to refresh after opting in (or out — we
 * unmount immediately on rejection too).
 */
export function ConsentGatedAnalytics() {
  const [consent, setConsent] = useState<ConsentLevel | null>(() => {
    if (typeof window === "undefined") return null;
    return readConsentFromDocument();
  });

  useEffect(() => {
    function handler(e: Event) {
      const detail = (e as CustomEvent<ConsentLevel>).detail;
      setConsent(detail);
    }
    window.addEventListener("fm-consent-changed", handler as EventListener);
    return () => window.removeEventListener("fm-consent-changed", handler as EventListener);
  }, []);

  if (consent !== "all") return null;
  return <Analytics />;
}
